module.exports = __webpack_public_path__ + "static/media/AB_shadow_angel_mobile_2.ae31a339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_shadow_angel_mobile_2.png
// module id = 544
// module chunks = 0